<template>
    <v-card class="my-1" v-if="Object.keys(charge).length > 0">
        <v-card-text class="py-1">
            <v-alert
                border="top"
                color="error darken-2"
                outlined
                icon="mdi-alert"
                v-if="charge.filtered"
            >
                <v-chip small color="error darken-2" class="mr-2"
                    >FILTERED</v-chip
                >{{ meta.description }}
            </v-alert>
            <div v-if="mode === 'print'" class="d-flex justify-end">
                <span v-if="charge.exclude" class="font-weight-bold"><v-icon color="warning" class="mr-1">mdi-alert</v-icon>Student excluded record from report on {{charge.exclude_date}}</span>
            </div>
            <div v-else class="d-flex justify-end">
                <v-checkbox v-model="exclude"  label="This is not me - remove from report" color="primary" @change="$emit('exclude',charge.id)" />
             </div>
            <v-divider class="my-2" color="grey"></v-divider>
            <div class="d-flex">
                <div class="mx-3" style="width: 100%">
                    <div class="d-flex align-center">
                        <v-avatar
                            size="40"
                            :color="charge.degreeColor"
                            rounded
                            class="mr-3"
                        >
                            <div class="d-flex flex-column">
                                <v-icon size="25" class="white--text"
                                    >mdi-scale-balance</v-icon
                                >
                            </div>
                        </v-avatar>
                        <h3>{{ detail.description }}</h3>
                    </div>

                    <div class="d-flex mt-3">
                        <v-chip
                            label
                            small
                            class="
                                text-center
                                align-center
                                d-flex
                                justify-center
                            "
                            :color="charge.degreeColor"
                            style="width: 120px"
                            ><h4 class="mx-auto text-center align-center">
                                {{ charge.degree }}
                            </h4></v-chip
                        >
                        <v-chip
                            small
                            :color="charge.dispositionColor"
                            class="ml-4 pl-0 white--text"
                        >
                            <v-icon class="mr-1 white--text">{{
                                charge.dispositionIcon
                            }}</v-icon>
                            <span class="text-uppercase">{{
                                charge.disposition
                            }}</span></v-chip
                        >
                        <v-spacer></v-spacer>
                        <v-chip
                            small
                            class="text-uppercase grey--text text--darken-1"
                            >{{ charge.status }}</v-chip
                        >
                    </div>
                    <v-divider class="my-2" color="grey"></v-divider>
                    
                
                    <div class="d-flex">
                        <span class="d-inline" style="width: 120px"
                            >Full Name:</span
                        >
                        <span class="font-weight-bold">
                            {{ fullName }}
                        </span>
                        <v-spacer></v-spacer>
                        <v-tooltip
                            v-if="
                                $_.get(meta, 'review', false) &&
                                mode !== 'print'
                            "
                            top
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                    v-on="on"
                                    v-bind="attrs"
                                    color="warning darken-2"
                                    small
                                    class="text-uppercase"
                                    >Review Required</v-chip
                                >
                            </template>
                            <span>{{ $_.get(meta, "description") }}</span>
                        </v-tooltip>
                    </div>
                    <div class="d-flex">
                        <span class="d-inline" style="width: 120px"
                            >Address:</span
                        >
                        <span class="font-weight-bold">{{ address }} </span>
                    </div>
                    <div class="d-flex">
                        <span class="d-inline" style="width: 120px">DOB:</span>
                        <span class="font-weight-bold">{{ record.dob }} </span>
                    </div>
                    <v-divider class="my-2" color="grey"></v-divider>
                    <div class="mt-2">
                        <h4 class="mb-1">Dates</h4>
                        <template
                            v-for="(
                                { icon = '', date = '', from = '', label = '' },
                                index
                            ) in getChargeDates(charge)"
                        >
                            <div class="d-flex" :key="index">
                                <v-icon class="mr-3">{{ icon }}</v-icon>
                                <span
                                    class="d-inline mr-3"
                                    style="width: 120px"
                                    >{{ label }}</span
                                >
                                <h4>{{ date ? date : "" }}</h4>
                                <v-spacer></v-spacer>
                                <v-chip small>{{ from }}</v-chip>
                            </div>
                            <v-divider
                                class="my-2"
                                color="grey ligthen-2"
                                :key="`divider-${index}`"
                            ></v-divider>
                        </template>
                    </div>

                    <div class="mt-2">
                        <h4 class="mb-1">Details</h4>
                        <template
                            v-for="(
                                { icon, label, text, type }, index
                            ) in charge.info"
                        >
                            <div class="d-flex" :key="index">
                                <v-icon class="mr-3">{{ icon }}</v-icon>
                                <v-chip
                                    label
                                    small
                                    class="mr-3"
                                    color="grey lighten-3"
                                    style="width: 90px"
                                    >{{ label }}</v-chip
                                >
                                <v-spacer></v-spacer>
                                <v-chip
                                    v-if="type === 'chip'"
                                    :color="charge.degreeColor"
                                    dark
                                    small
                                    class="text-uppercase font-weight-bold"
                                    >{{ text }}</v-chip
                                >
                                <span v-else class="font-weight-bold">{{
                                    text
                                }}</span>
                            </div>
                            <v-divider
                                v-if="index < charge.info.length - 1"
                                class="my-2"
                                color="grey ligthen-2"
                                :key="`divider-${index}`"
                            ></v-divider>
                        </template>
                    </div>
                </div>
            </div>
        </v-card-text>
        <v-card-actions v-if="mode === 'screen'">
            <div class="mx-3">
                <span
                    class="
                        grey-text
                        text--lighten-1
                        font-weight-light
                        text-caption
                        d-block
                    "
                    >Vendor: {{ footer.vendor }}</span
                >
                <span
                    class="
                        grey-text
                        text--lighten-1
                        font-weight-light
                        text-caption
                        d-block
                    "
                    >Source: {{ footer.source }}</span
                >
                <span
                    class="
                        grey-text
                        text--lighten-1
                        font-weight-light
                        text-caption
                        d-block
                    "
                    >{{ footer.info }}</span
                >
            </div>
            <v-spacer></v-spacer>
            <v-btn
                :disabled="!hasMoreDetails"
                small
                color="secondary"
                class="mr-3 mt-6"
                @click.stop="dialog = true"
                >More Details</v-btn
            >
        </v-card-actions>

        <v-dialog v-model="dialog" max-width="960">
            <component
                :is="detailsComponent"
                @close="dialog = false"
                scrollable
                v-if="dialog"
                :case-details="caseDetails"
            ></component>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    name: "screen-charge",
    components: {
        ScreenOjinCaseDetails: () => import("./ScreenOjinCaseDetails"),
        ScreenNpdCaseDetails: () => import("./ScreenNpdCaseDetails"),
    },
    props: {
        charge: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            required: false,
            default: "screen",
        },
    },
    data() {
        return {
            dialog: false,
            exclude: false,
        };
    },
    computed: {
        detail() {
            return this.$_.get(this.charge, "tag.detail", {});
        },
        caseDetails() {
            return this.$_.get(this.charge, "case", {});
        },
        record() {
            return this.$_.get(this.charge, "record", {});
        },
        info() {
            return this.$_.get(this.charge, "info", {});
        },
        meta() {
            return this.$_.get(this.charge, "meta", {});
        },
        address() {
            return this.$_.get(this.charge, "record.addresses[0].street", "");
        },
        fullName() {
            return this.$_.has(this.charge, "case.fullName")
                ? this.charge.case.fullName
                : this.$_.has(this.charge.record, "firstName")
                ? this.createFullName(this.charge.record)
                : "";
        },
        detailsComponent() {
            return `screen-${this.charge.source}-case-details`;
        },
        hasMoreDetails() {
            return Array.isArray(this.caseDetails)
                ? false
                : Object.keys(this.caseDetails).length > 0;
        },
        footer() {
            return {
                vendor: this.charge.source.toUpperCase(),
                source:
                    this.$_.has(this.charge, "tag.detail.sourceName") !== "N/A"
                        ? this.charge.tag.detail.sourceName
                        : this.$_.get(this.charge, "tag.detail.source"),
                info: this.$_.has(this.charge, "tag.detail.importDate")
                    ? `Import Date: ${this.charge.tag.detail.importDate}`
                    : `Source State: ${this.$_.get(
                          this.charge,
                          "tag.detail.sourceState",
                          "N/A"
                      )}`,
            };
        },
    },
    methods: {
        createFullName({ firstName, middleName, lastName }) {
            return middleName
                ? `${firstName} ${middleName} ${lastName}`
                : `${firstName} ${lastName}`;
        },
        getChargeDates(charge) {
            const chargeDates = ["dispositionDate", "offenseDate", "fileDate"]
                .filter(
                    (field) =>
                        this.$_.has(charge, field) &&
                        this.charge[field] !== null
                )
                .map((field) => charge[field]);
            return chargeDates;
        },
    },
};
</script>

